import { Box, Skeleton } from '@mui/material'
import React from 'react'

import type { DeviceType } from '@/src/types/deviceType'

interface DateCarouselShimmerProps {
    deviceType?: DeviceType
    itemWidth?: number
    gap?: number
}

const DEFAULTS = {
    DESKTOP: { count: 8, itemWidth: 68, gap: 3 },
    MOBILE: { count: 5, itemWidth: 60, gap: 1.5 }
}

const DateCarouselShimmer: React.FC<DateCarouselShimmerProps> = ({ deviceType = 'MOBILE', itemWidth, gap }) => {
    const { count, itemWidth: width, gap: defaultGap } = deviceType === 'DESKTOP' ? DEFAULTS.DESKTOP : DEFAULTS.MOBILE
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                justifyContent: 'center',
                py: 2,
                gap: gap ?? defaultGap
            }}
        >
            {[...Array(count)].map((_, idx) => (
                <Box
                    key={idx}
                    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: itemWidth ?? width }}
                >
                    <Skeleton variant="text" width={(itemWidth ?? width) - 8} height={14} sx={{ mb: 0.5 }} />
                    <Skeleton
                        variant="rectangular"
                        width={(itemWidth ?? width) - 8}
                        height={16}
                        sx={{ mb: 0.2, borderRadius: 1 }}
                    />
                </Box>
            ))}
        </Box>
    )
}

export default DateCarouselShimmer
